"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ArrowWrapper = _styledComponents.default.span.attrs({
  "data-qa": "arrow-wrapper"
}).withConfig({
  displayName: "MobileDropdownArrow__ArrowWrapper",
  componentId: "sc-1gemgqq-0"
})(["fill:", ";display:flex;flex:1;justify-content:flex-end;"], function (props) {
  return props.theme.carvana.blue.primary;
});

var _ref2 = _react.default.createElement(ArrowWrapper, null, _react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "6",
  viewBox: "0 0 10 6"
}, _react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M0,5.19a.8.8,0,0,1,.23-.55L4.52.26A.9.9,0,0,1,5.16,0a.92.92,0,0,1,.63.28l4,4.38A.77.77,0,0,1,9.7,5.8a.87.87,0,0,1-1.2-.08L5.12,2,1.48,5.74a.88.88,0,0,1-1.21,0A.78.78,0,0,1,0,5.19"
}))));

var _ref3 = _react.default.createElement(ArrowWrapper, {
  "data-qa": "mobile-dropdown-arrow"
}, _react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "6",
  viewBox: "0 0 10 6"
}, _react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M0,.81a.78.78,0,0,0,.23.55L4.52,5.74A.9.9,0,0,0,5.16,6a.88.88,0,0,0,.63-.28l4-4.38A.77.77,0,0,0,9.71.2a.88.88,0,0,0-1.2.08L5.13,4,1.48.26A.88.88,0,0,0,.27.22.78.78,0,0,0,0,.81"
}))));

var MobileDropdownArrow = function MobileDropdownArrow(_ref) {
  var isExpanded = _ref.isExpanded;

  if (isExpanded) {
    return _ref2;
  }

  return _ref3;
};

var _default = MobileDropdownArrow;
exports.default = _default;
module.exports = exports.default;